<template>
    <div>
        <div class="tbl">
            <b-tabs>
                <b-tab title="Detalhes" active>
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 100%">Chave</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                 {{ rowData.chave}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 10%">UF</th>
                                <th style="width: 15%">NOP</th>
                                <th style="width: 10%">Tipo Operação</th>
                                <th style="width: 10%">Tipo Emissão</th>
                                <th style="width: 10%">Digito Verificador</th>
                                <th style="width: 5%">Ambiente</th>
                                <th style="width: 10%">DT Saida Entrada</th>
                                <th style="width: 10%">HR Saida Entrada</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                 {{ rowData.uf.nome}}
                                </td>
                                <td>
                                 {{ rowData.nop }}
                                </td>
                                <td>
                                 {{ rowData.liv_tp_operacao.descr }}
                                </td>
                                <td>
                                 {{ rowData.liv_tp_emissao.descr }}
                                </td>
                                <td>
                                 {{ rowData.digito_verificador }}
                                </td>
                                <td>
                                 {{ rowData.liv_tp_ambiente.descr }}
                                </td>
                                <td>
                                 {{ formatDate(rowData.dt_saida_entrada) }}
                                </td>
                                <td>
                                 {{ formatDate(rowData.hr_saida_entrada) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-tab>

                <b-tab title="Partes Envolvidas" >
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                              <th data-toggle="true" style="width: 10%"></th>
                              <th data-toggle="true" style="width: 10%">CNPJ</th>
                              <th data-toggle="true" style="width: 10%">Nome</th>
                              <th data-toggle="true" style="width: 15%">Endereço</th>
                              <th data-toggle="true" style="width: 12%">Bairro</th>
                              <th data-toggle="true" style="width: 10%">CEP</th>
                              <th data-toggle="true" style="width: 10%">Município</th>
                              <th data-toggle="true" style="width: 3%">Estado</th>
                              <th data-toggle="true" style="width: 10%">Email</th>
                              <th data-toggle="true" style="width: 10%">Telefone</th>
                            </tr>
                         </thead>

                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-if='rowData.doc_fiscal_partes_env.emi_endereco'>
                               <td>
                                <span class="badge badge-secondary">Emitente</span>
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.emi_cnpj }}
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.emi_nome }}
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.emi_endereco }} - {{ rowData.doc_fiscal_partes_env.emi_complemento }} - {{ rowData.doc_fiscal_partes_env.emi_numero }}
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.emi_bairro }}
                               </td>
                               <td>
                                <span v-if="rowData.doc_fiscal_partes_env.emi_cep">{{
                                  rowData.doc_fiscal_partes_env.emi_cep.toString().padStart(8, "0")
                                }}</span>
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.emi_nome_municipio }}
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.emi_uf }}
                               </td>
                               <td>
                                   <span v-if='rowData.doc_fiscal_partes_env.emi_email'>{{ rowData.doc_fiscal_partes_env.emi_email }}</span>
                               </td>
                               <td>
                                   <span v-if='rowData.doc_fiscal_partes_env.emi_telefone'>{{ rowData.doc_fiscal_partes_env.emi_telefone }}</span>
                               </td>
                            </tr>
                        </tbody>

                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-if='rowData.doc_fiscal_partes_env.des_endereco'>
                               <td>
                                <span class="badge badge-success">Destinatário</span>
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.des_cnpj }}
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.des_nome }}
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.des_endereco }} - {{ rowData.doc_fiscal_partes_env.des_complemento }} - {{ rowData.doc_fiscal_partes_env.des_numero }}
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.des_bairro }}
                               </td>
                               <td>
                                <span v-if="rowData.doc_fiscal_partes_env.des_cep">{{
                                  rowData.doc_fiscal_partes_env.des_cep.toString().padStart(8, "0")
                                }}</span>
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.des_nome_municipio }}
                               </td>
                               <td>
                                 {{ rowData.doc_fiscal_partes_env.des_uf }}
                               </td>
                               <td>
                                   <span v-if='rowData.doc_fiscal_partes_env.des_email'>{{ rowData.doc_fiscal_partes_env.des_email }}</span>
                               </td>
                               <td>
                                   <span v-if='rowData.doc_fiscal_partes_env.des_telefone'>{{ rowData.doc_fiscal_partes_env.des_telefone }}</span>
                               </td>
                            </tr>
                        </tbody>
                   </table>
                </b-tab>

                <b-tab v-if="rowData.doc_fiscal_produto" title="Produtos">
                    <table class="table-striped" id="mais">
                       <thead>
                           <tr>
                               <th style="width: 10%">Código</th>
                               <th style="width: 10%">Descrição</th>
                               <th style="width: 10%">NCM</th>
                               <th style="width: 5%">CFOP</th>
                               <th style="width: 10%">Unidade Comercial</th>
                               <th style="width: 5%">Quantidade Comercial</th>
                               <th style="width: 10%">Valor Tributário</th>
                               <th style="width: 10%">Valor Bruto</th>
                               <th style="width: 10%">Unidade Tributável</th>
                               <th style="width: 10%">Quantidade Tributável</th>
                               <th style="width: 10%">Valor Unitário da Tributação</th>
                           </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_fiscal_produto">
                               <td>
                                {{ item.cd_produto}}
                               </td>
                               <td>
                                {{ item.descr_produto }}
                               </td>
                               <td>
                                {{ item.ncm }}
                               </td>
                               <td>
                                {{ item.cfop }}
                               </td>
                               <td>
                                {{ item.unidade_comercial }}
                               </td>
                               <td>
                                {{ item.qtd_comercial }}
                               </td>
                               <td>
                                {{ formatNumber(item.vlr_unitario) }}
                               </td>
                               <td>
                                {{ formatNumber(item.vlr_bruto) }}
                               </td>
                               <td>
                                {{ item.unidade_tributavel }}
                               </td>
                               <td>
                                {{ item.qtd_tributavel }}
                               </td>
                               <td>
                                {{ formatNumber(item.vlr_unitario_tributacao) }}
                               </td>
                           </tr>
                       </tbody>
                   </table>
                </b-tab>

                <b-tab v-if="rowData.doc_fiscal_produto[0].doc_fiscal_veiculo" title="Veículos">
                    <div v-for="item in rowData.doc_fiscal_produto">
                        <div v-if="item.doc_fiscal_veiculo">
                           <table class="table-striped" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Chassi</th>
                                      <th style="width: 10%">Código Cor</th>
                                      <th style="width: 10%">Descrição da Cor</th>
                                      <th style="width: 10%">Ano do modelo</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;">
                                      <td>
                                       {{ item.doc_fiscal_veiculo.chassi}}
                                      </td>
                                      <td>
                                       {{ item.doc_fiscal_veiculo.cd_cor }}
                                      </td>
                                      <td>
                                       {{ item.doc_fiscal_veiculo.descricao_cor }}
                                      </td>
                                      <td>
                                       {{ item.doc_fiscal_veiculo.ano_modelo_fabricacao }}
                                      </td>
                                  </tr>
                              </tbody>
                           </table>
                        </div><!--.tab-pane-->
                    </div>
                </b-tab>

                <b-tab title="Sefaz" v-if="rowData.doc_fiscal_info_adicional">
                    <table class="table-striped" id="mais">
                        <thead>
                          <tr>
                              <th style="width: 50%">Contrato</th>
                              <th style="width: 50%">Fisco</th>
                          </tr>
                       </thead>
                       <tbody>
                           <tr class="bg-gray-light" style="display: table-row;" >
                              <td>
                               {{ rowData.doc_fiscal_info_adicional.info_adicional_interesse_contr }}
                              </td>
                              <td>
                               {{ rowData.doc_fiscal_info_adicional.info_adicional_interesse_fisco }}
                              </td>
                           </tr>
                        </tbody>
                    </table>
                    <table class="table-striped" id="mais">
                        <thead>
                          <tr>
                              <th style="width: 50%">Origem Processo</th>
                              <th style="width: 50%">Identificador</th>
                          </tr>
                       </thead>
                       <tbody>
                           <tr class="bg-gray-light" style="display: table-row;" >
                              <td>
                               {{ rowData.doc_fiscal_info_adicional.doc_fiscal_processo.indicador_origem_processo }}
                              </td>
                              <td>
                               {{ rowData.doc_fiscal_info_adicional.doc_fiscal_processo.identificador_processo }}
                              </td>
                           </tr>
                        </tbody>
                    </table>
                    <table class="table-striped" id="mais">
                        <thead>
                          <tr>
                              <th style="width: 50%">X Campo</th>
                              <th style="width: 50%">X Texto</th>
                          </tr>
                       </thead>
                       <tbody>
                           <tr class="bg-gray-light" style="display: table-row;" >
                              <td>
                               {{ rowData.doc_fiscal_info_adicional.doc_fiscal_uso_livre_fisco.xcampo }}
                              </td>
                              <td>
                               {{ rowData.doc_fiscal_info_adicional.doc_fiscal_uso_livre_fisco.xtexto }}
                              </td>
                           </tr>
                        </tbody>
                    </table>
                </b-tab>

                <b-tab title="Transporte" v-if="rowData.doc_fiscal_transporte">
                    <table class="table-striped" id="mais">
                        <thead>
                              <tr>
                                  <th style="width: 5%">Modalidade</th>
                                  <th style="width: 10%">Nome</th>
                                  <th style="width: 10%">CNPJ</th>
                                  <th style="width: 5%">CPF</th>
                                  <th style="width: 5%">IE</th>
                                  <th style="width: 5%">UF</th>
                                  <th style="width: 5%">Município</th>
                                  <th style="width: 10%">Endereço</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0" style="width: 5%">Município Gerador</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0" style="width: 5%">CFOP</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0" style="width: 5%">Alíquota Retenção</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0" style="width: 5%">BC ICMS Retenção</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0" style="width: 5%">ICMS Retido</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0" style="width: 5%">Valor Serviço</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo>0" style="width: 5%">Placa</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo>0" style="width: 5%">RNTRC</th>
                                  <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo>0" style="width: 5%">UF Veículo</th>
                              </tr>
                        </thead>
                        <tbody>
                               <tr class="bg-gray-light" style="display: table-row;">
                                  <td>
                                   {{ rowData.doc_fiscal_transporte.modalidade_frete }}
                                  </td>
                                  <td>
                                   {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_transpor.nome }}
                                  </td>
                                  <td>
                                   {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_transpor.cnpj }}
                                  </td>
                                  <td>
                                   {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_transpor.cpf }}
                                  </td>
                                  <td>
                                   {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_transpor.ie }}
                                  </td>
                                  <td>
                                   {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_transpor.uf }}
                                  </td>
                                  <td>
                                   {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_transpor.municipio }}
                                  </td>
                                  <td>
                                   {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_transpor.endereco }}
                                   </td>
                                   <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0">
                                    {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto.cd_municipio_fato_gerador }}
                                    </td>
                                    <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0">
                                     {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto.cfop }}
                                   </td>
                                   <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0">
                                    {{ formatNumber(rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto.vlr_alq_retencao) }}
                                  </td>
                                    <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0">
                                     {{ formatNumber(rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto.vlr_bc_retencao_icms) }}
                                   </td>
                                   <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0">
                                    {{ formatNumber(rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto.vlr_icms_retido) }}
                                  </td>
                                  <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto>0">
                                   {{ formatNumber(rowData.doc_fiscal_transporte.doc_fiscal_transporte_imposto.vlr_servico) }}
                                 </td>
                                   <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo>0">
                                    {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo.placa }}
                                  </td>
                                  <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo>0">
                                   {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo.rntrc }}
                                 </td>
                                 <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo>0">
                                  {{ rowData.doc_fiscal_transporte.doc_fiscal_transporte_veiculo.uf }}
                                </td>
                             </tr>
                        </tbody>
                    </table>
                    <table class="table-striped" id="mais" v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_volume[0]">
                        <thead>
                           <tr>
                               <th style="width: 10%">Quantidade Volume</th>
                               <th style="width: 10%">Espécie Volume</th>
                               <th style="width: 10%">Numeração Volume</th>
                               <th style="width: 10%">Marca</th>
                               <th style="width: 10%">Peso Bruto</th>
                               <th style="width: 10%">Peso Líquido</th>
                               <th v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_volume.doc_fiscal_transporte_vol_lacr>0" style="width: 10%">Número Lacre</th>
                           </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_fiscal_transporte.doc_fiscal_transporte_volume">
                              <td>
                              {{  formatNumber(item.qtd_volume) }}
                             </td>
                              <td>
                               {{  item.especie_volume }}
                              </td>
                              <td>
                               {{  item.numeracao_volume }}
                              </td>
                              <td>
                               {{  formatNumber(item.marca_volume) }}
                              </td>
                              <td>
                               {{  formatNumber(item.peso_bruto) }}
                              </td>
                              <td>
                               {{  formatNumber(item.peso_liquido) }}
                              </td>
                              <td v-if="rowData.doc_fiscal_transporte.doc_fiscal_transporte_volume.doc_fiscal_transporte_vol_lacr>0">
                               {{  item.doc_fiscal_transporte_vol_lacr.num_lacre }}
                              </td>
                            </tr>
                         </tbody>
                     </table>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>
  <script>
  import moment from 'moment'
  import accounting from 'accounting'
  export default {
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      onClick (event) {
        console.log('my-detail-row: on-click', event.target)
      },
      formatNumber (value) {
          return accounting.formatNumber(value, 2)
      },
      formatDate (value, fmt = 'D/MM/YYYY HH:mm') {
        return (value == null)
          ? ''
          : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      }
    },
  }
  </script>
